export default __webpack_public_path__ + "static/media/icon-20-icn-low-battery.a3b2a3a0.svg";